import { Line } from 'react-chartjs-2'

interface ViewErrorTimeseriesProps {
  chartData: TimeseriesData[]
}

interface TimeseriesData {
  timestamp: Date
  volume: number
}

export const ViewErrorTimeseries = ({ chartData }: ViewErrorTimeseriesProps) => {
  const newChartData = {
    labels: chartData.map((t) => new Date(t.timestamp).toLocaleTimeString()),
    datasets: [
      {
        label: 'Error Count',
        data: chartData.map((t) => t.volume),
        fill: true,
        backgroundColor: 'rgba(75,192,192,0.2)',
        borderColor: 'rgba(75,192,192,1)',
      },
    ],
  }

  return (
    <div className="max-h-48 min-w-[720px]">
      <Line
        data={newChartData}
        options={{
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
            },
            x: {
              grid: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
            },
          },
        }}
      />
    </div>
  )
}
